import { render, staticRenderFns } from "./Service.vue?vue&type=template&id=73fde38e&scoped=true&"
import script from "./Service.vue?vue&type=script&lang=js&"
export * from "./Service.vue?vue&type=script&lang=js&"
import style0 from "./Service.vue?vue&type=style&index=0&id=73fde38e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../workspace/yajatravel/mp/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73fde38e",
  null
  
)

export default component.exports